import { Card, CardBody, CardImg, CardTitle } from 'reactstrap';
import { useDashboardStats } from '../../Api/queriesDashboard';
import fourImg from './../../assets/images/delivery.png';
import LoadingSpiner from '../components/LoadingSpiner';
import { useNavigate } from 'react-router-dom';
import { connectedUserRole } from '../Authentication/userInfos';

export default function TotalFounisseurs() {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/fournisseurs');
  };
  return (
    <div
      onClick={() => connectedUserRole === 'admin' && handleNavigate()}
      style={{ cursor: 'pointer' }}
    >
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={fourImg}
            alt='Fournisseurs'
            style={{ height: '90px', objectFit: 'contain' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-info fs-5'>
                {stats?.fournisseurs?.total ?? 0}
              </span>
              <p>Fournisseurs</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
}
